import React from 'react';

export const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
        stars.push(
            <i
                key={i}
                className={i <= rating ? "fas fa-star filled-star" : "far fa-star empty-star"}
                style={{ marginRight: "2px" }}
            ></i>
        );
    }
    return stars;
};